// extracted by mini-css-extract-plugin
export default {"skeletonRectangle":"LNzSEQ"};